import { bus_hinhthuc_dontra } from '../../models/response/bus/bus_hinhthuc_dontra';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_HINHTHUC_DONTRA_PATH = "bus/hinhthuc-dontra";

class BusHinhThucDonTraApi extends BaseCRUDApi<bus_hinhthuc_dontra> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const busHinhThucDonTraApi = new BusHinhThucDonTraApi(API_BUS_HINHTHUC_DONTRA_PATH);
